export class EndoMultiToothExamCavityDataModel {
  MTEToothCavitieID: string;
  MTEToothID: string;
  ToothSurfaceId: string;
  isCavity: boolean;
}
